import gql from 'graphql-tag'

export const getMonthlyReportPurchases = gql`
  query monthly_purchase_report($start_date: String!, $end_date: String!){
    records: monthly_purchase_report(start_date: $start_date, end_date: $end_date)
  }
`
